// Translations for NL (primary), EN, DE
export const TRANSLATIONS = {
  nl: {
    nav: {
      home: "Home",
      properties: "Aanbod",
      services: "Diensten",
      about: "Wie We Zijn",
      blog: "Journaal",
      contact: "Contact",
      viewing: "Boek Bezichtiging",
    },
    home: {
      heroOverline: "NM Luxury Estates · Costa del Sol",
      heroTitle: "Uw Nederlands-Duitse makelaar aan de Costa del Sol.",
      heroSubtitle:
        "Persoonlijke begeleiding, off-market kansen en discrete acquisitie van uitzonderlijk vastgoed in Marbella, Estepona, Sotogrande, Benahavís, Torremolinos, Mijas en Fuengirola.",
      heroCtaPrimary: "Krijg Direct Toegang tot Off-Market Woningen",
      heroCtaSecondary: "Spreek Met Mia",
      sectionUspOverline: "De NM Manier",
      sectionUspTitle: "Discreet. Internationaal. Onmiskenbaar van klasse.",
      uspOne: {
        title: "Diepgaande Lokale Kennis",
        body: "Onze sterke aanwezigheid in Marbella, Estepona, Benahavís, Casares, Sotogrande, Torremolinos, Mijas en Fuengirola betekent dat wij de markt tot in detail kennen. Torremolinos is bijzonder populair onder Nederlandse kopers.",
      },
      uspTwo: {
        title: "Volledige Transparantie",
        body: "Wij geloven in open communicatie en heldere processen. Geen verborgen kosten, geen onverwachte stappen.",
      },
      uspThree: {
        title: "Off-market Toegang",
        body: "Meer dan 1.000 woningen, waaronder exclusieve off-market kansen die nooit publiek aangeboden worden.",
      },
      featuredOverline: "Geselecteerd Aanbod",
      featuredTitle: "Op dit moment in onze portefeuille.",
      featuredCta: "Volledig aanbod bekijken",
      foundersOverline: "Wie We Zijn",
      foundersTitle: "Het hart van NM Luxury Estates.",
      foundersBody:
        "Michael CEJ Hannes en Nancy C. Hannes vormen samen het hart van NM Luxury Estates. Met een internationaal netwerk en een persoonlijke aanpak begeleiden zij kopers van eerste bezichtiging tot sleuteloverdracht.",
      foundersCta: "Maak Kennis",
      experienceOverline: "Service",
      experienceTitle: "De Persoonlijke Viewing Experience",
      experienceBody:
        "Onze viewing service omvat een zorgvuldig samengestelde selectie, planning en persoonlijke begeleiding. De investering hiervoor bedraagt €798,- netto en wordt bij aankoop van een object volledig gecrediteerd.",
      experienceCta: "Boek Uw Dag",
      experienceCaption: "Ophaalservice in Marbella · Inclusief NM Luxury chauffeur",
      reviewsOverline: "Vertrouwen",
      reviewsTitle: "Wat onze klanten zeggen.",
      ctaTitle: "Klaar om uw plek onder de zon te vinden?",
      ctaBody: "Wij staan klaar voor een vrijblijvend, vertrouwelijk gesprek.",
      ctaPrimary: "Plan een Gesprek",
    },
    properties: {
      overline: "Aanbod",
      title: "Vind uw droomwoning aan de Costa del Sol.",
      filtersTitle: "Filter",
      location: "Locatie",
      type: "Type",
      bedrooms: "Slaapkamers",
      minPrice: "Vanaf (€)",
      maxPrice: "Tot (€)",
      apply: "Toepassen",
      reset: "Wissen",
      anyLocation: "Alle locaties",
      anyType: "Alle types",
      any: "Alle",
      noResults: "Geen woningen gevonden met deze criteria.",
      loading: "Aanbod laden…",
      viewDetails: "Bekijken",
      perPage: "per pagina",
      total: "woningen gevonden",
      bedsLabel: "slpk",
      bathsLabel: "bdk",
      buildLabel: "m² bw",
    },
    detail: {
      back: "Terug naar aanbod",
      reference: "Referentie",
      requestInfo: "Vraag informatie aan",
      bookViewing: "Plan bezichtiging",
      features: "Kenmerken",
      description: "Omschrijving",
      contactAgent: "Neem contact op",
      sendInquiry: "Verstuur aanvraag",
      inquirySent: "Bedankt. Wij nemen spoedig contact met u op.",
      inquiryError: "Er ging iets mis. Probeer het opnieuw.",
      name: "Naam",
      email: "E-mailadres",
      phone: "Telefoon",
      message: "Bericht",
      bedrooms: "Slaapkamers",
      bathrooms: "Badkamers",
      built: "Bouwopp.",
      plot: "Perceel",
      terrace: "Terras",
      pool: "Zwembad",
      garden: "Tuin",
      parking: "Parkeerplaats",
      yes: "Ja",
      no: "Nee",
    },
    services: {
      overline: "Onze Diensten",
      title: "Een service die net zo onderscheidend is als uw woning.",
      acquisition: {
        title: "Property Finder",
        body: "Wij zoeken, selecteren en onderhandelen exclusief voor u. Toegang tot on- én off-market kansen.",
      },
      investment: {
        title: "Investerings­begeleiding",
        body: "Strategisch advies over rendement, locatieanalyse en juridische zekerheid voor internationale kopers.",
      },
      relocation: {
        title: "Relocatie",
        body: "Volledige begeleiding bij uw verhuizing — van NIE-nummer tot scholen, banken en gezondheidszorg.",
      },
      experienceTitle: "Persoonlijke Viewing Experience",
      experiencePrice: "€798",
      experienceTagline: "Eén dag. Twaalf woningen. Eén toegewijd team.",
      experienceFull:
        "Onze viewing service omvat een zorgvuldig samengestelde selectie, planning en persoonlijke begeleiding. De investering hiervoor bedraagt €798,- netto en wordt bij aankoop van een object volledig gecrediteerd.",
      experienceCredit: "Volledig gecrediteerd bij aankoop van een object.",
      experienceInclude1: "Pre-selectie van maximaal 12 woningen",
      experienceInclude2: "Privé chauffeur in luxe SUV",
      experienceInclude3: "Lunch in een geselecteerd restaurant",
      experienceInclude4: "Persoonlijk debrief en aankoopstrategie",
      bookTitle: "Reserveer uw Viewing Experience",
      bookSuccess: "Uw aanvraag is ontvangen. Wij bellen u binnen 24 uur terug.",
      bookError: "Er is iets misgegaan. Probeer het opnieuw of bel ons direct.",
      preferredDate: "Voorkeursdatum",
      locations: "Voorkeurslocaties",
      budget: "Budget indicatie",
      notes: "Aanvullende wensen",
      submit: "Bevestig boeking",
    },
    about: {
      overline: "Wie We Zijn",
      title: "Persoonlijke makelaardij op het hoogste niveau.",
      intro:
        "Als exclusief label van NM Luxury Estates staat Huis aan de Costa del Sol voor hoogwaardige vastgoedbegeleiding aan de prestigieuze Costa del Sol. Uw persoonlijke woonwensen vormen het vertrekpunt van een zorgvuldig en discreet aankooptraject.",
      paragraph1:
        "Als ervaren Nederlandse makelaar combineren wij internationale marktkennis met diepgewortelde lokale expertise in topregio's als Marbella, Estepona, Sotogrande, Benahavís, Torremolinos, Mijas en Fuengirola. Torremolinos is bijzonder populair onder onze Nederlandse cliënten. Van luxe villa's en exclusieve appartementen tot high-end nieuwbouwprojecten en solide vastgoedbeleggingen — wij begeleiden u van A tot Z bij de aankoop van uw droomwoning in Zuid-Spanje.",
      paragraph2:
        "Met strategisch inzicht, lokale connecties en een scherp oog voor kwaliteit realiseren wij niet alleen een aankoop, maar een investering in levensstijl, comfort en waarde. Discretie, transparantie en persoonlijke service vormen daarbij de standaard.",
      michaelTitle: "Michael CEJ Hannes",
      michaelRole: "Oprichter & Senior Adviseur",
      michaelBody:
        "Michael Hannes heeft commercieel gewoond en gewerkt in Zürich, München en Kitzbühel (Oostenrijk). Hij is allesbehalve een typische Nederlandse makelaar; zijn internationale achtergrond maakt hem laagdrempelig in de omgang en stelt hem in staat moeiteloos te schakelen tussen talen om u optimaal te bedienen.",
      nancyTitle: "Nancy C. Hannes",
      nancyRole: "Mede-eigenaar & Klantbegeleiding",
      nancyBody:
        "Nancy C. Hannes groeide op in de wereld van de makelaardij in Rotterdam, waar zij de basis legde voor haar passie voor vastgoed en persoonlijke begeleiding. Vandaag vormt zij samen met haar partner het hart van NM Luxury Estates.",
    },
    blog: {
      overline: "Journaal",
      title: "Inzichten over vastgoed aan de Costa del Sol.",
      readMore: "Lees verder",
      back: "Terug naar alle artikelen",
      publishedOn: "Gepubliceerd op",
      by: "door",
    },
    contact: {
      overline: "Contact",
      title: "Laat uw zoektocht beginnen.",
      intro:
        "Wij beantwoorden uw vraag graag persoonlijk, binnen één werkdag. Vul het formulier in of bel ons direct.",
      formTitle: "Stuur een bericht",
      name: "Naam",
      email: "E-mailadres",
      phone: "Telefoon (optioneel)",
      message: "Bericht",
      submit: "Verstuur bericht",
      success: "Bedankt voor uw bericht. Wij nemen spoedig contact met u op.",
      error: "Er ging iets mis. Probeer het opnieuw.",
      officeTitle: "Kantoor",
      addressLabel: "Adres",
      hoursLabel: "Openingstijden",
      hours: "Ma–Vr: 10.00 – 17.00 uur\nZa: op afspraak\nZo: gesloten",
      phoneNancy: "Nancy",
      phoneMichael: "Michael",
    },
    mia: {
      title: "Mia · AI Concierge",
      subtitle: "Online · 24/7",
      placeholder: "Stel uw vraag aan Mia…",
      welcome:
        "Welkom bij Huis aan de Costa del Sol, hoe kan ik u helpen?",
      send: "Verzend",
      thinking: "Mia denkt na…",
      open: "Open chat",
      close: "Sluit chat",
    },
    footer: {
      tagline: "Nederlandse makelaar · Costa del Sol",
      rights: "Alle rechten voorbehouden.",
      legal: "Disclaimer",
      privacy: "Privacy",
      followUs: "Volg ons",
    },
  },
  en: {
    nav: {
      home: "Home",
      properties: "Portfolio",
      services: "Services",
      about: "Who We Are",
      blog: "Journal",
      contact: "Contact",
      viewing: "Book Viewing",
    },
    home: {
      heroOverline: "NM Luxury Estates · Costa del Sol",
      heroTitle: "Your Dutch-German realtor on the Costa del Sol.",
      heroSubtitle:
        "Personal guidance, off-market opportunities, and the discreet acquisition of exceptional homes in Marbella, Estepona, Sotogrande, Benahavís, Torremolinos, Mijas and Fuengirola.",
      heroCtaPrimary: "Get Direct Access to Off-Market Homes",
      heroCtaSecondary: "Talk to Mia",
      sectionUspOverline: "The NM Way",
      sectionUspTitle: "Discreet. International. Unmistakably refined.",
      uspOne: {
        title: "Deep Local Knowledge",
        body: "Our strong presence in Marbella, Estepona, Benahavís, Casares, Sotogrande, Torremolinos, Mijas and Fuengirola means we know the market in detail. Torremolinos is especially popular with Dutch buyers.",
      },
      uspTwo: {
        title: "Full Transparency",
        body: "We believe in open communication and clear processes. No hidden costs, no surprises.",
      },
      uspThree: {
        title: "Off-market Access",
        body: "Over 1,000 properties including exclusive off-market opportunities never publicly listed.",
      },
      featuredOverline: "Featured Portfolio",
      featuredTitle: "Currently in our portfolio.",
      featuredCta: "View full portfolio",
      foundersOverline: "Who We Are",
      foundersTitle: "The heart of NM Luxury Estates.",
      foundersBody:
        "Michael CEJ Hannes and Nancy C. Hannes are the heart of NM Luxury Estates. With an international network and a personal approach, they guide buyers from first viewing to final handover.",
      foundersCta: "Meet The Team",
      experienceOverline: "Service",
      experienceTitle: "The Personal Viewing Experience",
      experienceBody:
        "A fully curated day on the Costa del Sol: chauffeur, selected viewings, lunch and a personal debrief with Michael or Nancy. €798.",
      experienceCta: "Book Your Day",
      experienceCaption: "Pick-up service in Marbella · NM Luxury chauffeur included",
      reviewsOverline: "Trust",
      reviewsTitle: "What our clients say.",
      ctaTitle: "Ready to find your place under the sun?",
      ctaBody: "We are happy to have a confidential, no-obligation conversation.",
      ctaPrimary: "Schedule a Call",
    },
    properties: {
      overline: "Portfolio",
      title: "Find your dream home on the Costa del Sol.",
      filtersTitle: "Filters",
      location: "Location",
      type: "Type",
      bedrooms: "Bedrooms",
      minPrice: "From (€)",
      maxPrice: "To (€)",
      apply: "Apply",
      reset: "Reset",
      anyLocation: "Any location",
      anyType: "Any type",
      any: "Any",
      noResults: "No properties match these filters.",
      loading: "Loading portfolio…",
      viewDetails: "View",
      perPage: "per page",
      total: "properties found",
      bedsLabel: "bd",
      bathsLabel: "ba",
      buildLabel: "m² built",
    },
    detail: {
      back: "Back to portfolio",
      reference: "Reference",
      requestInfo: "Request information",
      bookViewing: "Schedule viewing",
      features: "Features",
      description: "Description",
      contactAgent: "Get in touch",
      sendInquiry: "Send inquiry",
      inquirySent: "Thank you. We will contact you shortly.",
      inquiryError: "Something went wrong. Please try again.",
      name: "Name",
      email: "Email",
      phone: "Phone",
      message: "Message",
      bedrooms: "Bedrooms",
      bathrooms: "Bathrooms",
      built: "Built",
      plot: "Plot",
      terrace: "Terrace",
      pool: "Pool",
      garden: "Garden",
      parking: "Parking",
      yes: "Yes",
      no: "No",
    },
    services: {
      overline: "Our Services",
      title: "A service as distinctive as your home.",
      acquisition: {
        title: "Property Finder",
        body: "We search, select and negotiate exclusively for you. Access to both on- and off-market opportunities.",
      },
      investment: {
        title: "Investment Advisory",
        body: "Strategic advice on yield, location analysis and legal certainty for international buyers.",
      },
      relocation: {
        title: "Relocation",
        body: "Full support for your relocation — from NIE numbers to schools, banking and healthcare.",
      },
      experienceTitle: "Personal Viewing Experience",
      experiencePrice: "€798",
      experienceTagline: "One day. Twelve homes. One devoted team.",
      experienceFull:
        "Our viewing service includes a carefully curated selection, planning and personal guidance. The investment is €798,- net and is fully credited upon the purchase of a property.",
      experienceCredit: "Fully credited upon the purchase of a property.",
      experienceInclude1: "Pre-selection of up to 12 properties",
      experienceInclude2: "Private chauffeur in luxury SUV",
      experienceInclude3: "Lunch at a selected restaurant",
      experienceInclude4: "Personal debrief and acquisition strategy",
      bookTitle: "Reserve your Viewing Experience",
      bookSuccess: "Your request has been received. We will call you back within 24 hours.",
      bookError: "Something went wrong. Please try again or call us directly.",
      preferredDate: "Preferred date",
      locations: "Preferred locations",
      budget: "Budget indication",
      notes: "Additional notes",
      submit: "Confirm booking",
    },
    about: {
      overline: "Who We Are",
      title: "Personal real estate at the highest level.",
      intro:
        "As an exclusive label of NM Luxury Estates, Huis aan de Costa del Sol stands for high-end real estate guidance on the prestigious Costa del Sol.",
      paragraph1:
        "As experienced Dutch realtors we combine international market knowledge with deep local expertise across Marbella, Estepona, Sotogrande, Benahavís, Torremolinos, Mijas and Fuengirola. Torremolinos is especially popular among our Dutch clientele. From luxury villas and exclusive apartments to high-end new-build projects and solid real estate investments — we guide you from A to Z in acquiring your dream property in southern Spain.",
      paragraph2:
        "With strategic insight, local connections and a sharp eye for quality we realise not only an acquisition, but an investment in lifestyle, comfort and long-term value. Discretion, transparency and personal service are the standard.",
      michaelTitle: "Michael CEJ Hannes",
      michaelRole: "Founder & Senior Advisor",
      michaelBody:
        "Michael Hannes lived and worked commercially in Zürich, Munich and Kitzbühel (Austria). He is not the typical Dutch agent; his international background makes him easy to engage with and allows him to switch effortlessly between languages to serve clients at the highest level.",
      nancyTitle: "Nancy C. Hannes",
      nancyRole: "Co-owner & Client Care",
      nancyBody:
        "Nancy C. Hannes grew up in the real estate world of Rotterdam, where she laid the foundations of her passion for property and personal guidance. Today she forms — together with her partner — the heart of NM Luxury Estates.",
    },
    blog: {
      overline: "Journal",
      title: "Insights on real estate on the Costa del Sol.",
      readMore: "Read more",
      back: "Back to all articles",
      publishedOn: "Published on",
      by: "by",
    },
    contact: {
      overline: "Contact",
      title: "Begin your search.",
      intro: "We respond personally, within one business day. Send a message or call us directly.",
      formTitle: "Send a message",
      name: "Name",
      email: "Email",
      phone: "Phone (optional)",
      message: "Message",
      submit: "Send message",
      success: "Thank you for your message. We will be in touch shortly.",
      error: "Something went wrong. Please try again.",
      officeTitle: "Office",
      addressLabel: "Address",
      hoursLabel: "Office hours",
      hours: "Mon–Fri: 10.00 – 17.00\nSat: by appointment\nSun: closed",
      phoneNancy: "Nancy",
      phoneMichael: "Michael",
    },
    mia: {
      title: "Mia · AI Concierge",
      subtitle: "Online · 24/7",
      placeholder: "Ask Mia anything…",
      welcome: "Welcome to Huis aan de Costa del Sol, how can I help you?",
      send: "Send",
      thinking: "Mia is thinking…",
      open: "Open chat",
      close: "Close chat",
    },
    footer: {
      tagline: "Dutch realtor · Costa del Sol",
      rights: "All rights reserved.",
      legal: "Legal",
      privacy: "Privacy",
      followUs: "Follow",
    },
  },
  de: {
    nav: {
      home: "Start",
      properties: "Angebot",
      services: "Leistungen",
      about: "Über Uns",
      blog: "Journal",
      contact: "Kontakt",
      viewing: "Besichtigung Buchen",
    },
    home: {
      heroOverline: "NM Luxury Estates · Costa del Sol",
      heroTitle: "Ihr niederländisch-deutscher Immobilienmakler an der Costa del Sol.",
      heroSubtitle:
        "Persönliche Begleitung beim Haus kaufen an der Costa del Sol. Exklusive Villen, off-market Chancen und diskrete Akquise in Marbella, Estepona, Sotogrande, Benahavís, Torremolinos, Mijas und Fuengirola.",
      heroCtaPrimary: "Direktzugang zu Off-Market-Immobilien",
      heroCtaSecondary: "Mit Mia Sprechen",
      sectionUspOverline: "Der NM-Weg",
      sectionUspTitle: "Diskret. International. Unverkennbar erlesen.",
      uspOne: {
        title: "Tiefe Marktkenntnis",
        body: "Als Immobilienmakler Costa del Sol mit starker Präsenz in Marbella, Estepona, Benahavís, Casares, Sotogrande, Torremolinos, Mijas und Fuengirola kennen wir den Markt im Detail. Torremolinos ist besonders bei niederländischen Käufern beliebt.",
      },
      uspTwo: {
        title: "Volle Transparenz",
        body: "Wir glauben an offene Kommunikation und klare Prozesse. Keine versteckten Kosten, keine Überraschungen — beim Haus kaufen an der Costa del Sol.",
      },
      uspThree: {
        title: "Off-Market-Zugang",
        body: "Über 1.000 Objekte inklusive exklusiver Villen und Off-Market-Chancen, die niemals öffentlich gelistet werden.",
      },
      featuredOverline: "Ausgewähltes Portfolio",
      featuredTitle: "Aktuell in unserem Portfolio.",
      featuredCta: "Gesamtes Portfolio ansehen",
      foundersOverline: "Über Uns",
      foundersTitle: "Das Herz von NM Luxury Estates.",
      foundersBody:
        "Michael CEJ Hannes und Nancy C. Hannes bilden das Herz von NM Luxury Estates. Mit einem internationalen Netzwerk und einer persönlichen Herangehensweise begleiten sie Käufer von der ersten Besichtigung bis zur Schlüsselübergabe.",
      foundersCta: "Team Kennenlernen",
      experienceOverline: "Service",
      experienceTitle: "Die Persönliche Viewing Experience",
      experienceBody:
        "Ein vollständig kuratierter Tag an der Costa del Sol: Chauffeur, ausgewählte Besichtigungen, Mittagessen und persönliches Debrief mit Michael oder Nancy. €798.",
      experienceCta: "Tag Buchen",
      experienceCaption: "Abholservice in Marbella · NM Luxury Chauffeur inklusive",
      reviewsOverline: "Vertrauen",
      reviewsTitle: "Was unsere Kunden sagen.",
      ctaTitle: "Bereit, Ihren Platz an der Sonne zu finden?",
      ctaBody: "Wir freuen uns auf ein vertrauliches, unverbindliches Gespräch.",
      ctaPrimary: "Termin Vereinbaren",
    },
    properties: {
      overline: "Portfolio",
      title: "Finden Sie Ihre Traumimmobilie an der Costa del Sol.",
      filtersTitle: "Filter",
      location: "Ort",
      type: "Typ",
      bedrooms: "Schlafzimmer",
      minPrice: "Ab (€)",
      maxPrice: "Bis (€)",
      apply: "Anwenden",
      reset: "Zurücksetzen",
      anyLocation: "Alle Orte",
      anyType: "Alle Typen",
      any: "Alle",
      noResults: "Keine Objekte mit diesen Filtern gefunden.",
      loading: "Portfolio wird geladen…",
      viewDetails: "Ansehen",
      perPage: "pro Seite",
      total: "Objekte gefunden",
      bedsLabel: "SZ",
      bathsLabel: "BZ",
      buildLabel: "m² bebaut",
    },
    detail: {
      back: "Zurück zum Portfolio",
      reference: "Referenz",
      requestInfo: "Informationen anfragen",
      bookViewing: "Besichtigung buchen",
      features: "Ausstattung",
      description: "Beschreibung",
      contactAgent: "Kontakt aufnehmen",
      sendInquiry: "Anfrage senden",
      inquirySent: "Vielen Dank. Wir melden uns in Kürze.",
      inquiryError: "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
      name: "Name",
      email: "E-Mail",
      phone: "Telefon",
      message: "Nachricht",
      bedrooms: "Schlafzimmer",
      bathrooms: "Badezimmer",
      built: "Bebaut",
      plot: "Grundstück",
      terrace: "Terrasse",
      pool: "Pool",
      garden: "Garten",
      parking: "Parkplatz",
      yes: "Ja",
      no: "Nein",
    },
    services: {
      overline: "Unsere Leistungen",
      title: "Ein Service so unverwechselbar wie Ihr Zuhause.",
      acquisition: {
        title: "Property Finder",
        body: "Wir suchen, wählen aus und verhandeln exklusiv für Sie. Zugang zu On- und Off-Market-Chancen.",
      },
      investment: {
        title: "Investment Advisory",
        body: "Strategische Beratung zu Rendite, Standortanalyse und Rechtssicherheit für internationale Käufer.",
      },
      relocation: {
        title: "Relocation",
        body: "Vollumfängliche Begleitung Ihres Umzugs — von NIE-Nummer bis Schule, Bank und Gesundheitsversorgung.",
      },
      experienceTitle: "Persönliche Viewing Experience",
      experiencePrice: "€798",
      experienceTagline: "Ein Tag. Zwölf Häuser. Ein engagiertes Team.",
      experienceFull:
        "Unser Viewing-Service umfasst eine sorgfältig kuratierte Auswahl, Planung und persönliche Begleitung. Die Investition beträgt €798,- netto und wird beim Kauf einer Immobilie vollständig gutgeschrieben.",
      experienceCredit: "Beim Kauf einer Immobilie vollständig gutgeschrieben.",
      experienceInclude1: "Vorauswahl von bis zu 12 Objekten",
      experienceInclude2: "Privater Chauffeur im Luxus-SUV",
      experienceInclude3: "Mittagessen in einem ausgewählten Restaurant",
      experienceInclude4: "Persönliches Debrief und Erwerbsstrategie",
      bookTitle: "Reservieren Sie Ihre Viewing Experience",
      bookSuccess: "Ihre Anfrage ist eingegangen. Wir rufen innerhalb von 24 Stunden zurück.",
      bookError: "Etwas ist schiefgelaufen. Bitte erneut versuchen oder rufen Sie uns an.",
      preferredDate: "Wunschtermin",
      locations: "Wunschorte",
      budget: "Budget-Indikation",
      notes: "Zusätzliche Hinweise",
      submit: "Buchung bestätigen",
    },
    about: {
      overline: "Über Uns",
      title: "Persönliche Immobilienberatung auf höchstem Niveau — Ihr Immobilienmakler Costa del Sol.",
      intro:
        "Als exklusives Label von NM Luxury Estates steht Huis aan de Costa del Sol für hochwertige Immobilienbegleitung und exklusive Villen an der prestigeträchtigen Costa del Sol.",
      paragraph1:
        "Als erfahrener niederländischer Immobilienmakler verbinden wir internationale Marktkenntnis mit tief verwurzelter lokaler Expertise in Marbella, Estepona, Sotogrande, Benahavís, Torremolinos, Mijas und Fuengirola. Torremolinos ist bei unseren niederländischen Kunden besonders beliebt. Von Luxusvillen und exklusiven Apartments bis zu High-End-Neubauprojekten und soliden Immobilieninvestitionen — wir begleiten Sie von A bis Z beim Haus kaufen Costa del Sol.",
      paragraph2:
        "Mit strategischem Weitblick, lokalen Verbindungen und einem scharfen Auge für Qualität realisieren wir nicht nur einen Erwerb, sondern eine Investition in Lifestyle, Komfort und langfristigen Wert. Diskretion, Transparenz und persönlicher Service sind dabei Standard.",
      michaelTitle: "Michael CEJ Hannes",
      michaelRole: "Gründer & Senior Berater",
      michaelBody:
        "Michael Hannes hat in Zürich, München und Kitzbühel (Österreich) gelebt und kommerziell gearbeitet. Er ist kein typischer niederländischer Makler; sein internationaler Hintergrund macht ihn im Umgang angenehm und erlaubt es ihm, mühelos zwischen Sprachen zu wechseln, um Kunden auf höchstem Niveau zu betreuen. Ihr Immobilienmakler Costa del Sol für exklusive Villen.",
      nancyTitle: "Nancy C. Hannes",
      nancyRole: "Mitinhaberin & Kundenbetreuung",
      nancyBody:
        "Nancy C. Hannes wuchs in der Immobilienwelt von Rotterdam auf, wo sie das Fundament für ihre Leidenschaft für Immobilien und persönliche Begleitung legte. Heute bildet sie gemeinsam mit ihrem Partner das Herz von NM Luxury Estates.",
    },
    blog: {
      overline: "Journal",
      title: "Einblicke in Immobilien an der Costa del Sol.",
      readMore: "Weiterlesen",
      back: "Zurück zu allen Artikeln",
      publishedOn: "Veröffentlicht am",
      by: "von",
    },
    contact: {
      overline: "Kontakt",
      title: "Beginnen Sie Ihre Suche.",
      intro: "Wir antworten persönlich innerhalb eines Werktags. Senden Sie eine Nachricht oder rufen Sie uns direkt an.",
      formTitle: "Nachricht senden",
      name: "Name",
      email: "E-Mail",
      phone: "Telefon (optional)",
      message: "Nachricht",
      submit: "Nachricht senden",
      success: "Danke für Ihre Nachricht. Wir melden uns in Kürze.",
      error: "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
      officeTitle: "Büro",
      addressLabel: "Adresse",
      hoursLabel: "Öffnungszeiten",
      hours: "Mo–Fr: 10.00 – 17.00\nSa: nach Vereinbarung\nSo: geschlossen",
      phoneNancy: "Nancy",
      phoneMichael: "Michael",
    },
    mia: {
      title: "Mia · KI-Concierge",
      subtitle: "Online · 24/7",
      placeholder: "Fragen Sie Mia…",
      welcome: "Willkommen bei Huis aan de Costa del Sol, wie kann ich Ihnen helfen?",
      send: "Senden",
      thinking: "Mia überlegt…",
      open: "Chat öffnen",
      close: "Chat schließen",
    },
    footer: {
      tagline: "Niederländischer Makler · Costa del Sol",
      rights: "Alle Rechte vorbehalten.",
      legal: "Impressum",
      privacy: "Datenschutz",
      followUs: "Folgen",
    },
  },
  es: {
    nav: {
      home: "Inicio",
      properties: "Propiedades",
      services: "Servicios",
      about: "Quiénes Somos",
      blog: "Diario",
      contact: "Contacto",
      viewing: "Reservar Visita",
    },
    home: {
      heroOverline: "NM Luxury Estates · Costa del Sol",
      heroTitle: "Su agente neerlandés-alemán en la Costa del Sol.",
      heroSubtitle:
        "Acompañamiento personal, oportunidades off-market y la adquisición discreta de propiedades excepcionales en Marbella, Estepona, Sotogrande, Benahavís, Torremolinos, Mijas y Fuengirola.",
      heroCtaPrimary: "Acceso Directo a Propiedades Off-Market",
      heroCtaSecondary: "Hablar con Mia",
      sectionUspOverline: "El Estilo NM",
      sectionUspTitle: "Discreto. Internacional. Inequívocamente refinado.",
      uspOne: {
        title: "Profundo Conocimiento Local",
        body: "Nuestra fuerte presencia en Marbella, Estepona, Benahavís, Casares, Sotogrande, Torremolinos, Mijas y Fuengirola significa que conocemos el mercado en detalle. Torremolinos es especialmente popular entre los compradores neerlandeses.",
      },
      uspTwo: {
        title: "Transparencia Total",
        body: "Creemos en la comunicación abierta y en procesos claros. Sin costes ocultos, sin sorpresas.",
      },
      uspThree: {
        title: "Acceso Off-Market",
        body: "Más de 1.000 propiedades, incluidas exclusivas oportunidades off-market nunca publicadas.",
      },
      featuredOverline: "Cartera Destacada",
      featuredTitle: "Actualmente en nuestra cartera.",
      featuredCta: "Ver toda la cartera",
      foundersOverline: "Quiénes Somos",
      foundersTitle: "El corazón de NM Luxury Estates.",
      foundersBody:
        "Michael CEJ Hannes y Nancy C. Hannes son el corazón de NM Luxury Estates. Con una red internacional y un enfoque personal, acompañan a los compradores desde la primera visita hasta la entrega final.",
      foundersCta: "Conozca al Equipo",
      experienceOverline: "Servicio",
      experienceTitle: "La Experiencia de Visita Personalizada",
      experienceBody:
        "Un día totalmente curado en la Costa del Sol: chófer, visitas seleccionadas, comida y un debrief personal con Michael o Nancy. €798.",
      experienceCta: "Reserve Su Día",
      experienceCaption: "Servicio de recogida en Marbella · Incluye chofer NM Luxury",
      reviewsOverline: "Confianza",
      reviewsTitle: "Lo que dicen nuestros clientes.",
      ctaTitle: "¿Listo para encontrar su lugar al sol?",
      ctaBody: "Estaremos encantados de mantener una conversación confidencial y sin compromiso.",
      ctaPrimary: "Programar una Llamada",
    },
    properties: {
      overline: "Cartera",
      title: "Encuentre su hogar de ensueño en la Costa del Sol.",
      filtersTitle: "Filtros",
      location: "Ubicación",
      type: "Tipo",
      bedrooms: "Dormitorios",
      minPrice: "Desde (€)",
      maxPrice: "Hasta (€)",
      apply: "Aplicar",
      reset: "Restablecer",
      anyLocation: "Cualquier ubicación",
      anyType: "Cualquier tipo",
      any: "Cualquiera",
      noResults: "Ninguna propiedad coincide con estos filtros.",
      loading: "Cargando cartera…",
      viewDetails: "Ver",
      perPage: "por página",
      total: "propiedades encontradas",
      bedsLabel: "dor",
      bathsLabel: "baños",
      buildLabel: "m² construidos",
    },
    detail: {
      back: "Volver a la cartera",
      reference: "Referencia",
      requestInfo: "Solicitar información",
      bookViewing: "Programar visita",
      features: "Características",
      description: "Descripción",
      contactAgent: "Contacte con nosotros",
      sendInquiry: "Enviar consulta",
      inquirySent: "Gracias. Nos pondremos en contacto en breve.",
      inquiryError: "Algo ha ido mal. Inténtelo de nuevo.",
      name: "Nombre",
      email: "Email",
      phone: "Teléfono",
      message: "Mensaje",
      bedrooms: "Dormitorios",
      bathrooms: "Baños",
      built: "Construido",
      plot: "Parcela",
      terrace: "Terraza",
      pool: "Piscina",
      garden: "Jardín",
      parking: "Aparcamiento",
      yes: "Sí",
      no: "No",
    },
    services: {
      overline: "Nuestros Servicios",
      title: "Un servicio tan distintivo como su hogar.",
      acquisition: {
        title: "Property Finder",
        body: "Buscamos, seleccionamos y negociamos exclusivamente para usted. Acceso a oportunidades on- y off-market.",
      },
      investment: {
        title: "Asesoramiento de Inversión",
        body: "Asesoramiento estratégico sobre rentabilidad, análisis de ubicación y seguridad jurídica para compradores internacionales.",
      },
      relocation: {
        title: "Reubicación",
        body: "Acompañamiento integral para su mudanza — desde el NIE hasta colegios, banca y sanidad.",
      },
      experienceTitle: "Experiencia de Visita Personalizada",
      experiencePrice: "€798",
      experienceTagline: "Un día. Doce viviendas. Un equipo dedicado.",
      experienceFull:
        "Nuestro servicio de visitas incluye una selección cuidadosamente curada, planificación y acompañamiento personal. La inversión es de €798,- netos y se acredita íntegramente con la compra de una propiedad.",
      experienceCredit: "Se acredita íntegramente con la compra de una propiedad.",
      experienceInclude1: "Preselección de hasta 12 propiedades",
      experienceInclude2: "Chófer privado en SUV de lujo",
      experienceInclude3: "Comida en un restaurante seleccionado",
      experienceInclude4: "Debrief personal y estrategia de adquisición",
      bookTitle: "Reserve su Experiencia de Visita",
      bookSuccess: "Su solicitud ha sido recibida. Le llamaremos en 24 horas.",
      bookError: "Algo ha ido mal. Inténtelo de nuevo o llámenos directamente.",
      preferredDate: "Fecha preferida",
      locations: "Ubicaciones preferidas",
      budget: "Indicación de presupuesto",
      notes: "Notas adicionales",
      submit: "Confirmar reserva",
    },
    about: {
      overline: "Quiénes Somos",
      title: "Asesoramiento inmobiliario personal al más alto nivel.",
      intro:
        "Como sello exclusivo de NM Luxury Estates, Huis aan de Costa del Sol representa el asesoramiento inmobiliario de alta gama en la prestigiosa Costa del Sol.",
      paragraph1:
        "Como experimentado agente neerlandés, combinamos el conocimiento internacional del mercado con una profunda experiencia local en Marbella, Estepona, Sotogrande, Benahavís, Torremolinos, Mijas y Fuengirola. Torremolinos es especialmente popular entre nuestra clientela neerlandesa. Desde villas de lujo y apartamentos exclusivos hasta proyectos de obra nueva de alto nivel e inversiones inmobiliarias sólidas — le acompañamos de la A a la Z en la adquisición de su propiedad soñada en el sur de España.",
      paragraph2:
        "Con visión estratégica, conexiones locales y un ojo agudo para la calidad, no solo concretamos una compra, sino una inversión en estilo de vida, confort y valor a largo plazo. La discreción, la transparencia y el servicio personal son nuestro estándar.",
      michaelTitle: "Michael CEJ Hannes",
      michaelRole: "Fundador y Asesor Senior",
      michaelBody:
        "Michael Hannes ha vivido y trabajado comercialmente en Zúrich, Múnich y Kitzbühel (Austria). No es el típico agente neerlandés; su trayectoria internacional lo hace accesible en el trato y le permite cambiar con soltura entre idiomas para atender a los clientes al más alto nivel.",
      nancyTitle: "Nancy C. Hannes",
      nancyRole: "Co-propietaria y Atención al Cliente",
      nancyBody:
        "Nancy C. Hannes creció en el mundo inmobiliario de Róterdam, donde sentó las bases de su pasión por la propiedad y el acompañamiento personal. Hoy forma — junto con su socio — el corazón de NM Luxury Estates.",
    },
    blog: {
      overline: "Diario",
      title: "Perspectivas sobre el sector inmobiliario en la Costa del Sol.",
      readMore: "Leer más",
      back: "Volver a todos los artículos",
      publishedOn: "Publicado el",
      by: "por",
    },
    contact: {
      overline: "Contacto",
      title: "Comience su búsqueda.",
      intro: "Respondemos personalmente en un día laborable. Envíe un mensaje o llámenos directamente.",
      formTitle: "Enviar un mensaje",
      name: "Nombre",
      email: "Email",
      phone: "Teléfono (opcional)",
      message: "Mensaje",
      submit: "Enviar mensaje",
      success: "Gracias por su mensaje. Estaremos en contacto en breve.",
      error: "Algo ha ido mal. Inténtelo de nuevo.",
      officeTitle: "Oficina",
      addressLabel: "Dirección",
      hoursLabel: "Horario",
      hours: "Lun–Vie: 10.00 – 17.00\nSáb: con cita previa\nDom: cerrado",
      phoneNancy: "Nancy",
      phoneMichael: "Michael",
    },
    mia: {
      title: "Mia · AI Concierge",
      subtitle: "Online · 24/7",
      placeholder: "Pregúntele a Mia…",
      welcome: "Bienvenido a Huis aan de Costa del Sol, ¿cómo puedo ayudarle?",
      send: "Enviar",
      thinking: "Mia está pensando…",
      open: "Abrir chat",
      close: "Cerrar chat",
    },
    footer: {
      tagline: "Agente neerlandés · Costa del Sol",
      rights: "Todos los derechos reservados.",
      legal: "Legal",
      privacy: "Privacidad",
      followUs: "Síganos",
    },
  },
};

export const LANGS = [
  { code: "nl", label: "NL" },
  { code: "en", label: "EN" },
  { code: "de", label: "DE" },
  { code: "es", label: "ES" },
];
